export default __webpack_public_path__ + "static/chatain-60d4ed6ab9f4d30f070ee74b5401e3d6.svg";